import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaChevronLeft, FaChevronRight, FaArrowRight, FaCheckCircle } from 'react-icons/fa';

const ProductCard = ({ product }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  const images = product.images && product.images.length > 0 
    ? product.images 
    : [{ id: 0, image_path: '/Photo/peace-i17-pro-poster.jpg', label: 'Device View' }];

  const nextImage = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setCurrentImageIndex((prev) => (prev + 1) % images.length);
  };

  const prevImage = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setCurrentImageIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  // Format specs for the card
  const renderCardSpecs = (specsData) => {
    if (!specsData) {
      return <p className="card-product-desc">{product.description || 'Peace smartphone device.'}</p>;
    }

    let items = [];
    if (typeof specsData === 'string') {
      items = specsData
        .split(/[\n|]+/)
        .map(s => s.trim())
        .filter(Boolean);
    } else if (typeof specsData === 'object' && !Array.isArray(specsData)) {
      items = Object.entries(specsData).map(([key, val]) => `${key.charAt(0).toUpperCase() + key.slice(1)}: ${val}`);
    } else if (Array.isArray(specsData)) {
      items = specsData.map(s => String(s).trim()).filter(Boolean);
    }

    if (items.length === 0) {
      return <p className="card-product-desc">{product.description || 'Peace smartphone device.'}</p>;
    }

    return (
      <ul className="card-specs-list">
        {items.slice(0, 5).map((spec, idx) => (
          <li key={idx} className="card-spec-item">
            <FaCheckCircle className="card-spec-icon" />
            <span>{spec}</span>
          </li>
        ))}
      </ul>
    );
  };

  return (
    <div 
      className="peace-product-card"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Image Stage with Angle Carousel */}
      <div className="card-image-stage">
        <Link to={`/products/${product.id}`} className="card-image-link" aria-label={product.name}>
          <img 
            src={images[currentImageIndex] ? images[currentImageIndex].image_path : images[0].image_path} 
            alt={product.name}
            className="card-main-image"
            loading="lazy"
          />
        </Link>

        {/* Carousel Arrow Controls (Visible when more than 1 image exists) */}
        {images.length > 1 && (
          <>
            <button 
              className={`carousel-nav-btn prev-btn ${isHovered ? 'visible' : ''}`}
              onClick={prevImage}
              aria-label="Previous photo"
            >
              <FaChevronLeft />
            </button>
            <button 
              className={`carousel-nav-btn next-btn ${isHovered ? 'visible' : ''}`}
              onClick={nextImage}
              aria-label="Next photo"
            >
              <FaChevronRight />
            </button>

            {/* Micro Dot Indicators */}
            <div className="carousel-dots-row">
              {images.map((img, idx) => (
                <button
                  key={img.id || idx}
                  className={`carousel-dot ${idx === currentImageIndex ? 'active' : ''}`}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setCurrentImageIndex(idx);
                  }}
                  aria-label={`View photo ${idx + 1}`}
                />
              ))}
            </div>
          </>
        )}
      </div>

      {/* Content & Specs from Backend */}
      <div className="card-body-content">
        <div className="card-title-group">
          <h3 className="card-product-title">
            <Link to={`/products/${product.id}`} className="title-link">
              {product.name}
            </Link>
          </h3>
        </div>

        {/* Specifications displayed instead of description */}
        <div className="card-specs-container">
          {renderCardSpecs(product.specs || product.description)}
        </div>
      </div>

      {/* Card Action Link */}
      <div className="card-footer-actions">
        <div className="card-button-group">
          <Link 
            to={`/products/${product.id}`} 
            className="card-cta-btn primary-btn full-width"
          >
            Explore Device <FaArrowRight className="btn-arrow ms-1" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
